import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class DashboardCard extends PureComponent {
  render() {
    const { title, value, icon } = this.props;
    return (
      <div className="col mt-2 stat-widget-min-width">
        <div className="card h-100">
          <div className="card-body">
            <div className="stat-widget-five">
              <div className="stat-icon dib flat-color-1">
                <i className={icon} />
              </div>
              <div className="stat-content">
                <div className="text-left dib">
                  <div className="stat-text">
                    {value && <span className="count">{value || 0}</span>}
                  </div>
                  <div className="stat-heading">{title}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
DashboardCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
};

export default DashboardCard;
